import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('gjs-user-tenant-dropdown', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'user-tenant-dropdown',
    blocks: ['user-tenant-dropdown'],
    defaultStyle: true,
    label: 'Switch Tenant (D)',
    category: 'CMS',
    type: 'user-tenant-dropdown',
    labels: {
      labelNavItemSubMenuToggle: 'Tenant Toggle',
      labelNavItemDropdownMenu: 'Tenant Menu',
    },
    types: {
      nav_item_dropdown: 'navbar_item_dropdown',
      nav_item_dropdown_menu: 'navbar_item_dropdown_menu',
    },
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
